import React, { useState, useEffect } from "react";

import ListView from "./help/ListView";
// import Details from "./help/Details";
import Form from "./help/Form";

import axiosInstance from 'utils/axiosInstance';
import { useLocalStorage } from 'utils/storage';

import { fetchValues } from "services/values";

const Values = ({
    setShowContent
}) => {
    const [currentState, setCurrentState] = useState('list');

    const [values, setValues] = useLocalStorage('values', []);

    const [itemToEdit, setItemToEdit] = useState(null);

    const handleFormSubmit = async (form) => {
        try {
            let response;

            if (form.uid) {
                response = await axiosInstance.post(`/api/values/${form.uid}`, form);
            } else {
                response = await axiosInstance.post("/api/values", form);
            }

            const itemInResponse = response.data.data;

            setValues((currentItems) => {
                const isEditing = currentItems.some(n => n.uid === itemInResponse.uid);

                if (isEditing) {
                    return currentItems.map(item =>
                        item.uid === itemInResponse.uid ? itemInResponse : item
                    );
                } else {
                    return [...currentItems, itemInResponse];
                }
            });

            setCurrentState('list');
        } catch (error) {
            console.error('Failed to save value:', error);
        }
    };

    const handleDelete = async (uid) => {
        try {
            await axiosInstance.delete(`/api/values/${uid}`);

            setValues((items) => items.filter(n => n.uid !== uid));

            if (currentState !== 'list') {
                setCurrentState('list');
            }
        } catch (error) {
            console.error('Failed to delete value:', error);
        }
    };
    
    useEffect(() => {
        fetchValues().then((data) => {
            if (data) {
                setValues(data);
            }
        });
    }, []);


    // const handleOpenDetails = async (item) => {
    //     setSelectedItem(item);
    //     setCurrentState('details');
    // }

    // const handleCloseDetails = () => {        
    //     setSelectedItem(null);
    //     setCurrentState('list');
    // }

    const handleEdit = (group) => {
        setItemToEdit(group);
        setCurrentState('edit');
    };

    const handleFormCancel = () => {
        setItemToEdit(null);
        setCurrentState('list');
    }

    const handleBackButton = () => {
        setShowContent(false);
    }

    const renderCurrentView = () => {
        switch (currentState) {
            case "list":
                return (
                    <ListView
                        items={values}
                        // onClickHandler={handleOpenDetails}
                        onDeleteHandler={handleDelete}
                        onEditHandler={handleEdit}
                        onBackClick={handleBackButton}
                        setCurrentState={setCurrentState}
                    />
                );
            // case "details":
            //     return (
            //         <Details
            //             item={selectedItem}
            //             onEditHandler={handleEdit}
            //             onDeleteHandler={handleDelete}
            //             onCloseHandler={handleCloseDetails}
            //         />
            //     );
            case "add":
            case "edit":
                return (
                    <Form
                        itemToEdit={itemToEdit}
                        onFormSubmit={handleFormSubmit}
                        onCancelHandler={handleFormCancel}
                    />
                );
            default:
                return <div>Unknown state</div>;
        }
    };

    return (
        renderCurrentView()
    );
};

export default Values;
